/**
 * This function is used to handle the enter key when the cursor is inside of an editable element
 * like a codeblock. It will move the cursor to the next block or create a new block
 * if there is no next block when pressing Enter+Shift.
 */
export const handleInlineEnter = ({ block, editor, event, requireShiftKey = false, }) => {
    if (event.key === 'Enter' && (requireShiftKey ? event.shiftKey : true)) {
        event.preventDefault();
        // Switch the focus from CodeMirror back to the editor
        editor.focus();
        // Move the cursor to the current block
        editor.setTextCursorPosition(block);
        // Get the next block if it exists
        const nextBlock = editor.getTextCursorPosition().nextBlock;
        if (nextBlock) {
            // Move the cursor to the next block
            editor.setTextCursorPosition(nextBlock, 'start');
        }
        else {
            // If there is no next block, create a new paragraph block
            const [newBlock] = editor.insertBlocks([
                {
                    type: 'paragraph',
                },
            ], block, 'after');
            // And move the cursor to the new block
            editor.setTextCursorPosition(newBlock, 'start');
        }
    }
};
//# sourceMappingURL=handleInlineEnter.js.map